import { getClientConfig } from '@/lib/clients';

export const MAX_STANDARD_FACETS = 5;

// These are now delegated to the client config.
// For components that use React context (useClientConfig), prefer reading from config directly.
// These exports exist for backward compat with non-context code.
const config = getClientConfig();

export const categoriesToHide = config.ui.categoriesToHide;
export const EXAMPLE_QUERIES = config.ui.exampleQueries;
export const TOP_SEARCHES = config.ui.topSearches;

// Design tokens are defined in globals.css @theme block.
// Use Tailwind classes: text-brand, bg-brand, text-text-primary,
// text-text-secondary, bg-surface-muted, border-border-default.
// No JS color constants needed — CSS is the single source of truth.
